import { t } from "@lingui/macro";
import { DataTable } from "@src/components/ui-kit";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";
import type { BrandCreditAccountsSummaryModel } from "./models";

export const BoxCreditAccountsSummary: FunctionComponent<{
  summary?: BrandCreditAccountsSummaryModel;
  projectsCount: number;
  isLoaded: boolean;
}> = observer(function BoxCreditAccountsSummary({
  summary,
  projectsCount,
  isLoaded,
}) {
  const { total_credit, total_debit, remaining_credit } = summary ?? {
    total_credit: 0,
    total_debit: 0,
    remaining_credit: 0,
  };

  return (
    <DataTable.SummaryBox justify="space-around">
      <DataTable.SummaryItem label={t`Projects`} isLoaded={isLoaded}>
        {projectsCount}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem label={t`Credit (Total)`} isLoaded={isLoaded}>
        {currency.formatByWorkspace(total_credit, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem label={t`Debit (Total)`} isLoaded={isLoaded}>
        {currency.formatByWorkspace(total_debit, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem
        label={t`Remaining credit (Total)`}
        isLoaded={isLoaded}
      >
        {currency.formatByWorkspace(remaining_credit, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
    </DataTable.SummaryBox>
  );
});
